import { getDynamicCurrency } from '@/util-conversion/currency';
import { InsurancePlan, VehiclePlan } from '../types';
import getPlanNameFromMiles from '@/account/utils/get-plan-name-from-miles';

interface UsePackageSummaryProps {
  selectedMileagePlanId?: string;
  selectedInsurancePlanId?: string;
  vehiclePlans: VehiclePlan[] | null;
  insurancePlans?: InsurancePlan[];
  savingsAvailable?: boolean;
  estimatedSavings?: number;
}

export type PackageSummary = {
  mileagePlanName: string;
  insurancePlanName: string;
  estimatedMonthlyCostCopy: string;
  savingsAvailable?: boolean;
  estimatedSavingsCopy?: string;
};

export default function usePackageSummary({
  selectedMileagePlanId,
  selectedInsurancePlanId,
  vehiclePlans,
  insurancePlans,
  savingsAvailable,
  estimatedSavings,
}: UsePackageSummaryProps): PackageSummary | undefined {
  if (
    selectedMileagePlanId === undefined ||
    selectedInsurancePlanId === undefined ||
    !vehiclePlans ||
    !insurancePlans
  ) {
    return;
  }
  const mileagePlan = vehiclePlans.find(
    (plan) => plan.id === parseInt(selectedMileagePlanId)
  );
  const insurancePlan = insurancePlans.find(
    (plan) => plan.id === parseInt(selectedInsurancePlanId)
  );
  if (!mileagePlan || !insurancePlan) {
    return;
  }
  const estimatedMonthlyCost =
    mileagePlan.plan_price_per_mile * mileagePlan.miles_per_month +
    mileagePlan.base_price_per_month +
    insurancePlan.price_per_month;
  const estimatedSavingsCopy =
    savingsAvailable && estimatedSavings !== undefined && estimatedSavings > 0
      ? `${getDynamicCurrency(estimatedSavings)}`
      : undefined;
  return {
    mileagePlanName: getPlanNameFromMiles(mileagePlan.miles_per_month) ?? '',
    insurancePlanName: insurancePlan.name,
    estimatedMonthlyCostCopy: `${getDynamicCurrency(estimatedMonthlyCost)} + Tax`,
    estimatedSavingsCopy,
  };
}
